import styled from 'styled-components';
import { colors } from "../../utils/colors";
import backgroundPattern from '../../assets/home/BD-PATTERN.png'
import backgroundNavigation from '../../assets/home/darkblue-footer-background.png';

export const Background = styled.div`
    margin-top: 100px;
    width: 100vw;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 100px 60px 100px;
    background: url(${backgroundPattern});
    background-repeat: no-repeat;
    background-size: cover;

    @media (max-width: 1200px) {
        min-height: calc(100vh - 150px);
        padding: 60px 40px 150px;
    }

    @media (max-width: 500px) {
        min-height: auto;
        padding: 0 0 40px 0;
        background: url(${backgroundNavigation});
    }
`;

export const LoginBackground = styled.div`
    position: relative;
    max-width: 550px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: ${(prop) => prop.isBusiness ? '45px 60px 60px' : '60px'};

    @media (max-width: 500px) {
        padding: 20px 20px 20px 32px;
        justify-content: flex-start;
    }
`;

export const LoginBackgroundImage = styled.img`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    @media (max-width: 500px) {
        display: none;
    }
`;

export const LoginTitle = styled.h1`
    color: ${colors.CREAM};
    font-family: 'Courgette', cursive;
    margin-bottom: 25px;
    z-index: 10;
    position: relative;
    left: -12px;

    @media (max-width: 460px) {
        margin-bottom: 10px;
    }

    @media (max-width: 340px) {
        margin-bottom: 25px;
    }
`;

export const LoginSubtitle = styled.p`
    color: ${colors.WHITE};
    font-family: 'Courgette', cursive;
    margin-bottom: 50px;
    text-align: center;
    z-index: 15;
    width: 90%;
    position: relative;
    left: -12px;

    @media (max-width: 460px) {
        margin-bottom: 10px;
    }
`;

export const LoginInput = styled.input`
    z-index: 3;
    height: 30px;
    background: #fff;
    border: 1px solid transparent;
    box-shadow: 0 2px 5px 1px rgb(64 60 67 / 16%);
    border-radius: 24px;
    width: 90%;
    margin-bottom: ${(prop) => prop.isBusiness ? '10px' : '30px'};
    padding-left: 15px;
    position: relative;
    left: -12px;

    @media (max-width: 500px) {
        width: 100%;
    }
`;

export const LoginButton = styled.button`
    background-color: ${colors.CREAM};
    color: ${colors.BLUE};
    font-family: 'Dancing Script', cursive;
    border: none;
    padding: 8px 0;
    border-radius: 25px;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: .2s ease-in;
    margin-bottom: 30px;
    position: relative;
    left: -10px;
    width: 50%;

    &:hover{
        cursor: pointer;
        transform: translateY(-2px);
        color: ${colors.WHITE};
    }
`;

export const LoginRegistration = styled.p`
    color: ${colors.CREAM};
    font-size: 18px;
    margin-top: 10px;
    font-family: 'Dancing Script', cursive;
    position: relative;
    left: -10px;
    text-align: center;
    transition: .2s ease-in;
    padding: 8px 10px;

    &:hover{
        background-color: ${colors.CREAM};
        color: ${colors.BLUE};
        cursor: pointer;
        border-radius: 25px;
        -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        transition: .2s ease-in;
    }
`;